import "./_glossario.scss";

document.addEventListener('DOMContentLoaded', () => {
    const contenitoriGlossario = document.querySelectorAll('.block__glossario');

    contenitoriGlossario.forEach(container => {
        const inputRicerca = container.querySelector('.input-ricerca');
        const bottoniLettere = container.querySelectorAll('.btn-lettera:not([disabled])');
        const sezioni = container.querySelectorAll('.sezione-lettera');
        const cards = container.querySelectorAll('.card-termine');

        // 1. Accordion
        cards.forEach(card => {
            const header = card.querySelector('.termine-header'); 
            
            header.addEventListener('click', () => {
                const definizione = card.querySelector('.termine-definizione');
                const isOpen = card.classList.contains('is-open');
                const icona = card.querySelector('.icona-accordion');

                // Chiude le altre
                cards.forEach(c => {
                    c.classList.remove('is-open');
                    c.querySelector('.termine-definizione').style.display = 'none';
                    c.querySelector('.icona-accordion').textContent = '+';
                });

                if (!isOpen) {
                    card.classList.add('is-open');
                    definizione.style.display = 'block';
                    icona.textContent = '-';
                }
            });
        });

        // 2. Filtro per Lettera
        bottoniLettere.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const letteraCliccata = e.target.getAttribute('data-lettera');

                bottoniLettere.forEach(b => b.classList.remove('is-active'));
                e.target.classList.add('is-active');

                if (inputRicerca) inputRicerca.value = '';

                sezioni.forEach(sezione => {
                    const letteraSezione = sezione.getAttribute('data-sezione');
                    if (letteraCliccata === 'all' || letteraSezione === letteraCliccata) {
                        sezione.style.display = 'block';
                        sezione.querySelectorAll('.card-termine').forEach(c => c.style.display = 'block');
                    } else {
                        sezione.style.display = 'none';
                    }
                });
            });
        });

        // 3. Ricerca Live
        if (inputRicerca) {
            inputRicerca.addEventListener('input', (e) => {
                const termineCercato = e.target.value.toLowerCase().trim();

                bottoniLettere.forEach(b => b.classList.remove('is-active'));
                const btnTutti = container.querySelector('.btn-lettera[data-lettera="all"]');
                if (termineCercato === '' && btnTutti) {
                    btnTutti.classList.add('is-active');
                }

                sezioni.forEach(sezione => {
                    let haRisultati = false;
                    const cardsSezione = sezione.querySelectorAll('.card-termine');

                    cardsSezione.forEach(card => {
                        const titoloCard = card.getAttribute('data-termine');
                        if (titoloCard.includes(termineCercato)) {
                            card.style.display = 'block';
                            haRisultati = true;
                        } else {
                            card.style.display = 'none';
                        }
                    });

                    sezione.style.display = haRisultati ? 'block' : 'none';
                });
            });
        }
    });
});